/** Monetización (1.0 admin Monetization): destacados vigentes (`featured`) y escaparates activos (`wardrobeSpotlights`). */
import { useEffect, useState, type ReactElement } from 'react';
import { Link } from 'react-router-dom';
import { collection, getDocs, limit, orderBy, query, Timestamp, where } from 'firebase/firestore';
import { errorText } from '../api.js';
import { env } from '../env.js';
import { db } from '../firebase.js';
import { muted, Notice, str, Table, td, when } from '../lib/ui.js';

type Doc = Record<string, unknown>;

export function MonetizationPage(): ReactElement {
  const [featured, setFeatured] = useState<Doc[] | null>(null);
  const [spots, setSpots] = useState<Doc[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    const now = Timestamp.now();
    getDocs(
      query(
        collection(db, 'featured'),
        where('expires_at', '>', now),
        orderBy('expires_at', 'asc'),
        limit(200),
      ),
    )
      .then((s) => {
        setFeatured(s.docs.map((d) => ({ id: d.id, ...d.data() })));
      })
      .catch((e: unknown) => {
        setError(errorText(e));
        setFeatured([]);
      });
    getDocs(
      query(
        collection(db, 'wardrobeSpotlights'),
        where('active', '==', true),
        orderBy('expires_at', 'asc'),
        limit(200),
      ),
    )
      .then((s) => {
        setSpots(s.docs.map((d) => ({ id: d.id, ...d.data() })));
      })
      .catch((e: unknown) => {
        setError(errorText(e));
        setSpots([]);
      });
  }, []);
  return (
    <>
      <h1 style={{ margin: 0 }}>Monetización</h1>
      <p style={muted}>
        Precios y packs en Ajustes → featuredPrices; incluidos en PRO en Ajustes → proPlans. Aquí
        solo lo vigente.
      </p>
      <Notice text={error} error />
      <h2 style={{ margin: 0, fontSize: 16 }}>
        Destacados vigentes {featured ? `(${featured.length})` : ''}
      </h2>
      {featured && (
        <Table
          head={['Producto', 'Vendedor', 'Pack', 'Ámbito', 'País', 'Portada', 'Origen', 'Hasta']}
        >
          {featured.map((f) => (
            <tr key={str(f.id)}>
              <td style={td}>
                <a
                  href={`${env.VITE_WEB_ORIGIN}/es/p/${str(f.product_id)}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  {str(f.product_id)}
                </a>
              </td>
              <td style={td}>
                <Link to={`/usuarios/${str(f.seller_id)}`}>{str(f.seller_id).slice(-8)}</Link>
              </td>
              <td style={td}>{str(f.pack_code)}</td>
              <td style={td}>{str(f.scope)}</td>
              <td style={td}>{str(f.country)}</td>
              <td style={td}>{f.homepage === true ? 'sí' : 'no'}</td>
              <td style={td}>{str(f.source)}</td>
              <td style={td}>{when(f.expires_at)}</td>
            </tr>
          ))}
        </Table>
      )}
      <h2 style={{ margin: 0, fontSize: 16 }}>
        Escaparates activos {spots ? `(${spots.length})` : ''}
      </h2>
      {spots && (
        <Table head={['Vendedor', '@usuario', 'Origen', 'Desde', 'Hasta']}>
          {spots.map((s) => (
            <tr key={str(s.id)}>
              <td style={td}>
                <Link to={`/usuarios/${str(s.uid)}`}>{str(s.uid).slice(-8)}</Link>
              </td>
              <td style={td}>{str(s.username)}</td>
              <td style={td}>{str(s.source)}</td>
              <td style={td}>{when(s.starts_at)}</td>
              <td style={td}>{when(s.expires_at)}</td>
            </tr>
          ))}
        </Table>
      )}
    </>
  );
}
